import { Actions, thunk } from 'easy-peasy';
import formatSecondaryDiagnosis from '~/utils/formatSecondaryDiagnosis';
import api from '~/services/api';
import {
  IThunkCreateSecondaryDiagnosis,
  IClientDetailsStore,
  IClientDetailsActions,
} from '../types';

const onCreateSecondaryDiagnosis: IThunkCreateSecondaryDiagnosis = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    const { requestInfo, requestPayload } = payload;

    const secondaryDiagnosis = await api.clientDetails
      .createClientSecondaryDiagnosis(requestInfo, requestPayload)
      .then(r => formatSecondaryDiagnosis(r.data));

    const diagnoses = [secondaryDiagnosis, ...localState.diagnoses];

    setClientDetails({ diagnoses });
  },
);

export default onCreateSecondaryDiagnosis;
